import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as n, useEffect as c } from "react";

function o(t) {
  var _n = n(t),
      _n2 = _slicedToArray(_n, 2),
      s = _n2[0],
      e = _n2[1];

  return c(function () {
    e(t);
  }, [t]), [s, e];
}

export { o as usePropSyncedState };